import isDefinedAndNotEmpty from '../isDefinedAndNotEmpty.js';

const dbName = 'orgStylesDb';
const storeName = 'organizationStylesStore';
const VERSION = 1;

let db = null;
let disabled = false;

function getEventError(event) {
  const target = event !== null && event !== undefined ? event.target : null;
  const err = target !== null && target !== undefined ? target.error : null;
  if (err !== null && err !== undefined) {
    const name = typeof err.name === 'string' ? err.name : '';
    const msg = typeof err.message === 'string' ? err.message : '';
    const combined = (name + (msg.length > 0 ? ': ' + msg : '')).trim();
    return combined.length > 0 ? combined : 'Unknown';
  }
  return 'Unknown';
}

async function initDB() {
  return new Promise((resolve, reject) => {
    if (disabled === true) {
      resolve(null);
      return;
    }
    if (db !== null) {
      resolve(db);
      return;
    }

    if (typeof indexedDB === 'undefined' || indexedDB === null) {
      disabled = true;
      resolve(null);
      return;
    }

    let hasRetried = false;

    const openDatabase = () => {
      let request;
      try {
        request = indexedDB.open(dbName, VERSION);
      } catch (e) {
        disabled = true;
        resolve(null);
        return;
      }

      request.onupgradeneeded = (event) => {
        const tempDb = event.target.result;
        if (tempDb.objectStoreNames.contains(storeName) === false) {
          tempDb.createObjectStore(storeName, { keyPath: 'id' });
        }
      };

      request.onsuccess = (event) => {
        db = event.target.result;
        if (db !== null) {
          db.onversionchange = () => {
            try {
              db.close();
            } catch (e) {}
            db = null;
          };
        }
        resolve(db);
      };

      request.onerror = (event) => {
        const errStr = getEventError(event);
        const errLower = typeof errStr === 'string' ? errStr.toLowerCase() : '';
        if (errLower.indexOf('unknownerror') >= 0 || errLower.indexOf('internal error') >= 0 || errLower.indexOf('backing store') >= 0) {
          disabled = true;
          resolve(null);
          return;
        }
        if (hasRetried === false) {
          hasRetried = true;
          try {
            const delReq = indexedDB.deleteDatabase(dbName);
            delReq.onsuccess = () => {
              openDatabase();
            };
            delReq.onerror = () => {
              disabled = true;
              resolve(null);
            };
            delReq.onblocked = () => {
              disabled = true;
              resolve(null);
            };
          } catch (e) {
            disabled = true;
            resolve(null);
          }
        } else {
          disabled = true;
          resolve(null);
        }
      };

      request.onblocked = () => {
        disabled = true;
        resolve(null);
      };
    };

    openDatabase();
  });
}

async function getObjectStore(mode) {
  if (db === null) {
    await initDB();
  }
  if (db === null) {
    return null;
  }
  try {
    const transaction = db.transaction([storeName], mode);
    return transaction.objectStore(storeName);
  } catch (e) {
    try {
      if (db !== null) {
        db.close();
      }
    } catch (closeErr) {}
    db = null;
    await initDB();
    if (db === null) {
      return null;
    }
    try {
      const transactionRetry = db.transaction([storeName], mode);
      return transactionRetry.objectStore(storeName);
    } catch (e2) {
      disabled = true;
      return null;
    }
  }
}

async function saveOrgStyles({ css, js }) {
  return new Promise(async (resolve, reject) => {
    const store = await getObjectStore('readwrite');
    if (store === null) {
      resolve();
      return;
    }
    const data = { id: 'currentStyles', css: isDefinedAndNotEmpty(css) != false ? css : '', js: isDefinedAndNotEmpty(js) != false ? js : '' };
    
    const request = store.put(data);

    request.onsuccess = () => {
      resolve();
    };

    request.onerror = (event) => {
      disabled = true;
      resolve();
    };
  });
}

async function loadOrgStyles() {
  return new Promise(async (resolve, reject) => {
    const store = await getObjectStore('readonly');
    if (store === null) {
      resolve(null);
      return;
    }
    const request = store.get('currentStyles');

    request.onsuccess = (event) => {
      if (event.target.result !== undefined) {
        resolve(event.target.result);
      } else {
        resolve(null);
      }
    };

    request.onerror = (event) => {
      disabled = true;
      resolve(null); 
    };
  });
}

async function clearOrgStyles() {
  return new Promise(async (resolve, reject) => {
    const store = await getObjectStore('readwrite');
    if (store === null) {
      resolve();
      return;
    }
    const request = store.delete('currentStyles');

    request.onsuccess = () => {
      resolve();
    };

    request.onerror = (event) => {
      disabled = true;
      resolve();
    };
  });
}

export { initDB, saveOrgStyles, loadOrgStyles, clearOrgStyles }; 